module.exports = __webpack_public_path__ + "img/bookingagora.19ab763c.png";